package org.gymly.ui.admin

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.theme.AdminColors
import org.gymly.util.WeekRange

@Composable
fun WeekNavigator(
    week: WeekRange,
    onWeekOffsetChange: (Int) -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(2.dp),
    ) {
        TextButton(onClick = { onWeekOffsetChange(week.weekOffset - 1) }) {
            Text("‹", color = AdminColors.Primary, fontSize = 22.sp, fontWeight = FontWeight.Bold)
        }
        OutlinedButton(
            onClick = { onWeekOffsetChange(0) },
            shape = RoundedCornerShape(10.dp),
        ) {
            Text(
                week.labelEs(),
                color = AdminColors.Text,
                fontSize = 13.sp,
                fontWeight = FontWeight.Medium,
                modifier = Modifier.padding(horizontal = 4.dp),
            )
        }
        TextButton(onClick = { onWeekOffsetChange(week.weekOffset + 1) }) {
            Text("›", color = AdminColors.Primary, fontSize = 22.sp, fontWeight = FontWeight.Bold)
        }
    }
}
